import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/Button';
import { Input } from '../components/ui/Input';
import { Card, CardContent } from '../components/ui/Card';
function RichTextEditor({
  label,
  defaultValue = '',
  highlighted = false
}: {
  label: string;
  defaultValue?: string;
  highlighted?: boolean;
}) {
  return <div data-id="element-529">
      <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-530">
        {label}
      </label>
      <div className="border border-slate-300 rounded-md overflow-hidden" data-id="element-531">
        <div className="flex items-center gap-0.5 px-2 py-1 bg-slate-100 border-b border-slate-300 flex-wrap" data-id="element-532">
          <button type="button" className="px-1.5 py-0.5 text-xs border border-slate-300 bg-white hover:bg-slate-50 rounded text-slate-600" data-id="element-533">
            Source
          </button>
          <span className="w-px h-4 bg-slate-300 mx-1" data-id="element-534" />
          {['📄', '📋', '✂', '🗑', '↩', '↪'].map((ic, i) => <button key={i} type="button" className="px-1 py-0.5 text-xs border border-transparent hover:border-slate-300 hover:bg-white rounded text-slate-500" data-id="element-535">
              {ic}
            </button>)}
          <span className="w-px h-4 bg-slate-300 mx-1" data-id="element-536" />
          {['🔍', '🔤', '🖊'].map((ic, i) => <button key={i} type="button" className="px-1 py-0.5 text-xs border border-transparent hover:border-slate-300 hover:bg-white rounded text-slate-500" data-id="element-537">
              {ic}
            </button>)}
        </div>
        <div className="flex items-center gap-0.5 px-2 py-1 bg-slate-100 border-b border-slate-300 flex-wrap" data-id="element-538">
          {['B', 'I', 'U', 'S'].map(t => <button key={t} type="button" className="w-6 h-6 text-xs font-bold border border-slate-300 bg-white hover:bg-slate-50 rounded text-slate-700" data-id="element-539">
              {t}
            </button>)}
          <span className="w-px h-4 bg-slate-300 mx-1" data-id="element-540" />
          {['≡', '≣', '❝', '»'].map((t, i) => <button key={i} type="button" className="w-6 h-6 text-xs border border-slate-300 bg-white hover:bg-slate-50 rounded text-slate-600" data-id="element-541">
              {t}
            </button>)}
          <span className="w-px h-4 bg-slate-300 mx-1" data-id="element-542" />
          <select className="h-6 text-xs border border-slate-300 bg-white rounded px-1" data-id="element-543">
            <option data-id="element-544">Styles</option>
          </select>
          <select className="h-6 text-xs border border-slate-300 bg-white rounded px-1" data-id="element-545">
            <option data-id="element-546">Format</option>
          </select>
          <select className="h-6 text-xs border border-slate-300 bg-white rounded px-1" data-id="element-547">
            <option data-id="element-548">Font</option>
          </select>
          <select className="h-6 text-xs border border-slate-300 bg-white rounded px-1" data-id="element-549">
            <option data-id="element-550">Size</option>
          </select>
          <span className="w-px h-4 bg-slate-300 mx-1" data-id="element-551" />
          {['A', 'A', '⊞', '⊟', '⊕', '?'].map((t, i) => <button key={i} type="button" className="w-6 h-6 text-xs border border-slate-300 bg-white hover:bg-slate-50 rounded text-slate-600" data-id="element-552">
              {t}
            </button>)}
        </div>
        <textarea className={`w-full p-3 text-sm focus:outline-none resize-y min-h-[140px] ${highlighted ? 'bg-yellow-50' : 'bg-white'}`} defaultValue={defaultValue} data-id="element-553" />
      </div>
    </div>;
}
const creditOptions = ['3 hrs. Agency Law', '3 hrs. Comm. Standards', '3 hrs. Fair Housing', '3 hrs. General', '3 hrs. Disclosure', '3 hrs. Property Mgmt'];
const categoryOptions = ['Courses/Products', 'Single class', 'Package', 'Bundle'];
const smallDescDefault = `CS CE credit + Complies with current NAR cycle January 2025-December 2027

The Commissioner's Rule R4-28-1101 will be the primary focus of the class as it compares to the NAR Code Of Ethics for REALTORS®. There will be a review of the process of enforcement of both the Rules and Code of Ethics. Recent changes will be addressed as well as those that are often overlooked.

REMEMBER:SEND A COPY OF YOUR CERTIFICATE TO YOUR LOCAL ASSOCIATION.
Find Email Address: https://www.DesertSageSeminars.com/Arizona_Local_Associations`;
const fullDescDefault = `CS CE credit + Complies with current NAR cycle January 2025-December 2027

The Commissioner's Rule R4-28-1101 will be the primary focus of the class as it compares to the NAR Code Of Ethics for REALTORS®. There will be a review of the process of enforcement of both the Rules and Code of Ethics. Recent changes will be addressed as well as those that are often overlooked.

REMEMBER:SEND A COPY OF YOUR CERTIFICATE TO YOUR LOCAL ASSOCIATION.
Find Email Address: https://www.DesertSageSeminars.com/Arizona_Local_Associations

****This Class Will Comply With NAR Code of Ethics requirement PLUS 3 CE hrs. for Commissioner's Standards***`;
export function EditCourse() {
  const {
    id
  } = useParams();
  const navigate = useNavigate();
  const isEdit = !!id;
  return <div className="space-y-4" data-id="element-554">
      <div className="flex items-center justify-between" data-id="element-555">
        <h1 className="text-2xl font-bold text-slate-900" data-id="element-556">
          {isEdit ? 'Edit Course' : 'Add Course'}
        </h1>
        <Button variant="secondary" size="sm" className="border border-slate-300 bg-gradient-to-b from-white to-slate-100 text-slate-700 shadow-sm" onClick={() => navigate('/courses')} data-id="element-557">
          ← Back to Courses
        </Button>
      </div>

      <Card data-id="element-558">
        <CardContent className="pt-6" data-id="element-559">
          <form className="space-y-5 max-w-2xl" data-id="element-560">
            <div data-id="element-561">
              <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-562">
                Position
              </label>
              <input type="text" defaultValue={isEdit ? '1' : ''} className="h-8 w-24 rounded border border-slate-300 bg-white px-2 text-sm focus:outline-none focus:ring-2 focus:ring-slate-400" data-id="element-563" />
            </div>

            <Input label="Name" defaultValue={isEdit ? 'Ethics & The Rules (with NAR Code of Ethics)' : ''} className="max-w-sm" data-id="element-564" />

            <div data-id="element-565">
              <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-566">
                Category
              </label>
              <select defaultValue={isEdit ? 'Single class' : 'Courses/Products'} className="h-8 rounded border border-slate-300 bg-white px-2 text-sm focus:outline-none focus:ring-2 focus:ring-slate-400 min-w-[160px]" data-id="element-567">
                {categoryOptions.map(c => <option key={c} data-id="element-568">{c}</option>)}
              </select>
            </div>

            <RichTextEditor label="Small Description" defaultValue={isEdit ? smallDescDefault : ''} highlighted={isEdit} data-id="element-569" />

            <RichTextEditor label="Full Description" defaultValue={isEdit ? fullDescDefault : ''} highlighted={isEdit} data-id="element-570" />

            <div data-id="element-571">
              <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-572">
                Passing (%)
              </label>
              <input type="text" defaultValue={isEdit ? '80' : ''} className="h-8 w-24 rounded border border-slate-300 bg-white px-2 text-sm focus:outline-none focus:ring-2 focus:ring-slate-400" data-id="element-573" />
            </div>

            <div data-id="element-574">
              <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-575">
                Credit
              </label>
              <select defaultValue={isEdit ? '3 hrs. Comm. Standards' : '3 hrs. Agency Law'} className="h-8 rounded border border-slate-300 bg-white px-2 text-sm focus:outline-none focus:ring-2 focus:ring-slate-400 min-w-[180px]" data-id="element-576">
                {creditOptions.map(c => <option key={c} data-id="element-577">{c}</option>)}
              </select>
            </div>

            <div data-id="element-578">
              <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-579">
                Total Credits
              </label>
              <input type="text" defaultValue={isEdit ? '3' : ''} className="h-8 w-24 rounded border border-slate-300 bg-white px-2 text-sm focus:outline-none focus:ring-2 focus:ring-slate-400" data-id="element-580" />
            </div>

            <div data-id="element-581">
              <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-582">
                Course No
              </label>
              <input type="text" defaultValue={isEdit ? 'CD17355' : ''} className="h-8 w-32 rounded border border-slate-300 bg-white px-2 text-sm focus:outline-none focus:ring-2 focus:ring-slate-400" data-id="element-583" />
            </div>

            <div data-id="element-584">
              <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-585">
                Publish
              </label>
              <select defaultValue="Yes" className="h-8 rounded border border-slate-300 bg-white px-2 text-sm focus:outline-none focus:ring-2 focus:ring-slate-400" data-id="element-586">
                <option data-id="element-587">Yes</option>
                <option data-id="element-588">No</option>
              </select>
            </div>

            {isEdit && <>
                <div data-id="element-589">
                  <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-590">
                    Price
                  </label>
                  <input type="text" defaultValue="19.95" className="h-8 w-28 rounded border border-slate-300 bg-white px-2 text-sm focus:outline-none focus:ring-2 focus:ring-slate-400" data-id="element-591" />
                </div>

                <div data-id="element-592">
                  <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-593">
                    Crossed Price
                  </label>
                  <input type="text" defaultValue="" className="h-8 w-28 rounded border border-slate-300 bg-white px-2 text-sm focus:outline-none focus:ring-2 focus:ring-slate-400" data-id="element-594" />
                </div>

                <div className="flex items-center gap-2" data-id="element-595">
                  <input type="checkbox" id="availableInPackage" defaultChecked className="h-4 w-4 rounded border-slate-300 text-slate-800" data-id="element-596" />
                  <label htmlFor="availableInPackage" className="text-sm text-slate-700" data-id="element-597">
                    Available In Package
                  </label>
                </div>
              </>}

            <div className="pt-2" data-id="element-598">
              <Button type="submit" data-id="element-599">Submit</Button>
            </div>
          </form>
        </CardContent>
      </Card>
    </div>;
}